import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=10259488&"
import script from "./ContractDetail.vue?vue&type=script&lang=js&"
export * from "./ContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&id=10259488&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports